import React, { useState, useEffect, useContext } from 'react';

import Cookies from 'js-cookie';

import Dropdown from '../../common/Dropdown'
import CampaignMenu from '../CampaignMenu.js'

import { UserDataContext } from "../../../App.js";
import { DEFAULT_CAMPAIGN, CAMPAIGN_ASSETS_URL } from '../../../globals.js';
import getUploadUrl from '../../../helpers/getUploadUrl.js';
import updateCampaign from '../../../helpers/updateCampaign.js';
import { sanitizeRuleTitle } from '../../../helpers/sanitizeInput.js';

function RulesMenuCampaign(props) {

    // ------------ parameters ---------------

    // ------ inherited state variables ------
    let [currentChar, setChar] = [ props.state[0], props.state[1] ];
    let [layout, setLayout] = [ props.state[3], props.state[4] ];
    const [userData, setUserData] = useContext(UserDataContext);
    const [isPlaying, setIsPlaying] = props.state[8];
    const setRule = props.setRule;

    // -------- local state variables --------
    const [isTTS, setIsTTS] = useState(/Tabletop/i.test(navigator.userAgent));

    const isGreyhawk = userData.currentCampaign === DEFAULT_CAMPAIGN;
    const isAdmin = userData.dynamoData?.campaigns?.[userData.currentCampaign]?.role?.includes('admin')
        || userData.campaignData?.campaignOwner === userData.uniqueUser;

    // Build menu options
    let menuOptions;
    if (isGreyhawk) {
        menuOptions = ['Campaign Rules 1', 'Campaign Rules 2'];
    } else {
        const uploadedRules = userData.campaignData?.rules?.campaignRules || [];
        menuOptions = uploadedRules.map(r => r.title);
        if (isAdmin) {
            menuOptions.push('+ Add Rule');
        }
    }

    // -------------------------------------
    // EVENT HANDLER
    // -------------------------------------

    const handleMenu = (selection) => {

        if (menuOptions[selection] === '+ Add Rule') {
            const existingRules = userData.campaignData?.rules?.campaignRules || [];
            if (existingRules.length >= 10) {
                alert('Maximum of 10 campaign rules reached.');
                return;
            }

            // Must create and click the file input synchronously within the user gesture
            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = '.jpg,.jpeg,.png';
            fileInput.style.display = 'none';
            document.body.appendChild(fileInput);

            fileInput.onchange = async (e) => {
                const file = e.target.files[0];
                document.body.removeChild(fileInput);
                if (!file) return;

                if (file.size > 10 * 1024 * 1024) {
                    alert('File exceeds 10MB limit. Please select a smaller file.');
                    return;
                }

                const title = sanitizeRuleTitle(prompt('Enter a name for this rule:'));
                if (!title) return;

                const filetype = file.type;
                const filename = `${Date.now()}-${file.name.replace(/\s+/g, '_')}`;

                const urlData = await getUploadUrl(userData.currentCampaign, filename, filetype);
                if (!urlData) {
                    alert('Failed to get upload URL');
                    return;
                }

                try {
                    await fetch(urlData.presignedUrl, {
                        method: 'PUT',
                        body: file,
                        headers: { 'Content-Type': filetype }
                    });
                } catch (err) {
                    alert('Upload failed: ' + err.message);
                    return;
                }

                const newRule = { title, url: urlData.publicUrl, type: filetype };
                const updatedRules = { ...userData.campaignData?.rules, campaignRules: [...existingRules, newRule] };

                await updateCampaign(userData.currentCampaign, { rules: updatedRules });

                const newUserData = { ...userData };
                newUserData.campaignData = { ...userData.campaignData, rules: updatedRules };
                setUserData(newUserData);
            };

            fileInput.click();
            return;
        }

        let Img;
        let imgSet = false;

        if (isGreyhawk) {
            // Use Greyhawk20 S3 images
            const option = menuOptions[selection];
            Img = `${CAMPAIGN_ASSETS_URL}/${DEFAULT_CAMPAIGN}/${option.replace(/\s+/g, '')}.jpg`;
            imgSet = true;
        } else {
            // Use uploaded S3 URL
            const uploadedRules = userData.campaignData?.rules?.campaignRules || [];
            const rule = uploadedRules[selection];
            if (rule) {
                Img = rule.url;
                imgSet = true;
            }
        }

        // DISPLAY IMAGE IN WINDOW (if set)
        if ( imgSet ) {
            if ( props.setRule ) {
                setRule( { title: menuOptions[selection], source: Img })
            }

            document.getElementById('rulesWindow').style.display = 'block';
            return;
        }

    } // end of HANDLE FUNCTION


        // ------------  Return JSX  ----------------

    return (

        <>
        <Dropdown
            trigger = {<button className="nav-settings-button">Campaign</button>}
            menu = { menuOptions.map ( ( option, idx) => {

                if  ( option === 'Change Campaign' ) return <CampaignMenu key={idx} {...props} />

                else return <button id={'discord-option-' + idx } onClick={()=>handleMenu(idx)}>{option}</button>

                }
            )}
            divClass='menu-item sub-menu'
            menuClass="menu"
            onChildClose={props.onChildClose}
        />
        </>
    )

    };  // end of function

    export default RulesMenuCampaign